var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalBriefcase1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 5.79104C8.25 4.24959 9.48122 3 11 3H13C14.5188 3 15.75 4.24959 15.75 5.79104H18C20.2091 5.79104 22 7.60863 22 9.85075V13.9104C22 15.0315 21.1046 15.9403 20 15.9403H4C2.89543 15.9403 2 15.0315 2 13.9104V9.85075C2 7.60863 3.79086 5.79104 6 5.79104H8.25ZM9.75 5.79104H14.25C14.25 5.09038 13.6904 4.52239 13 4.52239H11C10.3096 4.52239 9.75 5.09039 9.75 5.79104ZM12.4 7.8209H11.6C11.3239 7.8209 11.1 8.04809 11.1 8.32836V9.95224H9.5C9.22386 9.95224 9 10.1794 9 10.4597V11.2716C9 11.5519 9.22386 11.7791 9.5 11.7791H11.1V13.403C11.1 13.6832 11.3239 13.9104 11.6 13.9104H12.4C12.6761 13.9104 12.9 13.6832 12.9 13.403V11.7791H14.5C14.7761 11.7791 15 11.5519 15 11.2716V10.4597C15 10.1794 14.7761 9.95224 14.5 9.95224H12.9V8.32836C12.9 8.04809 12.6761 7.8209 12.4 7.8209Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.826V17.9701C2 19.0912 2.89543 20 4 20H20C21.1046 20 22 19.0912 22 17.9701V16.826C21.4331 17.2273 20.7436 17.4627 20 17.4627H4C3.25638 17.4627 2.56692 17.2273 2 16.826Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalBriefcase1);
export default __webpack_public_path__ + "static/media/medical-briefcase-1.5f6c043eb9bbd7a227243ddfce23e7d2.svg";
export { ForwardRef as ReactComponent };